"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
var react_intl_1 = require("react-intl");
var TTablePagination = function (props) {
    var rowsPerPage = props.rowsPerPage, count = props.count, page = props.page, rowsPerPageOptions = props.rowsPerPageOptions, onChangePage = props.onChangePage, onChangeRowsPerPage = props.onChangeRowsPerPage, pagingInfoMessageId = props.pagingInfoMessageId, pagingInfoMessageIdIfNull = props.pagingInfoMessageIdIfNull;
    var pagesCount = Math.ceil(count / rowsPerPage);
    var from = page * rowsPerPage + 1;
    var to = (page + 1) * rowsPerPage;
    if ((page + 1) * rowsPerPage > count) {
        to = count;
    }
    var renderPaginationItem = function (item) {
        return react_1.default.createElement(lab_1.PaginationItem, __assign({}, item));
    };
    return (react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justify: "space-between", alignItems: "center" },
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, alignItems: "center", wrap: "nowrap" },
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Typography, null,
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.rowsPerPage", defaultMessage: "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C \u043F\u043E:" }))),
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.TextField, { select: true, size: "small", value: rowsPerPage, onChange: onChangeRowsPerPage, variant: "outlined" }, rowsPerPageOptions &&
                        rowsPerPageOptions.map(function (option) { return (react_1.default.createElement(core_1.MenuItem, { key: option, value: option }, option)); }))))),
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(lab_1.Pagination, { count: pagesCount, page: page + 1, onChange: onChangePage, color: "primary", showFirstButton: true, showLastButton: true, renderItem: renderPaginationItem })),
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Typography, null, count ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: pagingInfoMessageId, values: { count: count, from: from, to: to }, defaultMessage: "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044B c " + from + " \u043F\u043E " + to + " \u0438\u0437 " + count })) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: pagingInfoMessageIdIfNull, defaultMessage: "\u0417\u0430\u043F\u0438\u0441\u0438 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" }))))));
};
exports.default = TTablePagination;
